.janeGoldContainer {
  margin-top: 24px;
}

.janeGoldHeader {
  display: flex;
  gap: 8px;
  align-items: center;
}

.janeGoldInfoBox {
  display: flex;
  border: 1px solid var(--colors-grays-light);
  border-radius: 24px;
  margin-top: 16px;
  padding: 16px;
  justify-content: space-between;
  align-items: center;
}

.janelogoContainer {
  display: flex;
  gap: 16px;
}

.janeGoldText {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
